<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand">{{ routeName }}</a>     
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <drop-down
            class="nav-item"
            :title="this.$config.sites[this.$config.moniker].moniker_display_name"
            title-classes="nav-link"
            icon=""
            shiftleft="true"
          >
          <a class="dropdown-item" href="#" v-for="(site, index) in this.$config.sites" @click="changeMoniker(site.moniker)">
            {{site.moniker_display_name}}
          </a>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    changeMoniker (moniker) {
        this.$cookies.set('moniker', moniker);
        this.$updateConfigVariables({ user: 'moniker' });
        location.reload(); // Hacky but it works
    }
  },
};
</script>
<style>
.notification {
    font-size: 0.85rem;
}
</style>
